module.exports = __webpack_public_path__ + "media/images/footer/phinoe-white-20a758e9918ced57339cfc630aa75a83.svg";